<template>
  <Modal v-model="ContractCreateModal" width="800">
    <p slot="header" class="text-center">
        <Icon type="md-add"></Icon>
        <span>创建合同</span>
    </p>

    <Form
      ref="investmentContractModel"
      :model="investmentContractModel"
      autocomplete="on"
      name="oohforce-device-add"
      id="oohforce-device-add"
      :rules="ruleValidate"
      label-position="top"
    >
      <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="合同名称" prop="contractName">
            <Input
              v-model="investmentContractModel.contractName"
              size="small"
              placeholder="请输入合同名称"
            />
          </FormItem>
        </i-col>

        <i-col span="12">
          <FormItem label="合同甲方" prop="companyId">
            <i-select placeholder="市" v-model="investmentContractModel.companyId" size="small">
              <Option v-for="(item, index) in manageCompanyArray" :key="index" :value="item.id">
                {{ item.name }}
              </Option>
            </i-select>
          </FormItem>
        </i-col>
      </Row>

      <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="合同编号" prop="code">
            <Input
              v-model="investmentContractModel.code"
              size="small"
              placeholder="请输入合同编码，请勿重复录入"
            />
          </FormItem>
        </i-col>
        <i-col span="12">
          <FormItem label="用途">
            <RadioGroup v-model="investmentContractModel.purposeType">
              <Radio v-for="item in PurposeTypeArray" :key="'st_' + item.id" :label="item.id">{{ item.name }}</Radio>
            </RadioGroup>
          </FormItem>
        </i-col>
        <!-- <i-col span="8">
          <FormItem label="招商项目">
            <i-select
              v-model="investmentContractModel.investId"
              filterable
              clearable
              size="small"
              placeholder="请选择招商项目"
            >
              <i-option
                v-for="item in investmentArray"
                :value="item.id"
                :key="'st_' + item.id"
                >{{ item.name }}</i-option
              >
            </i-select>
          </FormItem>
        </i-col>
        <i-col span="8">
          <FormItem label="签约客户">
            <i-select
              v-model="investmentContractModel.orderNo"
              filterable
              size="small"
              placeholder="请选择签约客户"
            >
              <i-option
                v-for="item in orderArray"
                :value="item.orderNo"
                :key="'st_' + item.orderNo"
                >{{ item.userName }}</i-option
              >
            </i-select>
          </FormItem>
        </i-col> -->
      </Row>

      <Row :gutter="8" class="m-b-10">
        <i-col span="12">
          <FormItem label="合同类型（PS：仅影响账单的生成方式）">
            <RadioGroup v-model="investmentContractModel.contractType">
              <Radio :label="1">商业合同</Radio>
              <Radio :label="2">通信合同</Radio>
            </RadioGroup>
          </FormItem>
        </i-col>

        <i-col span="12">
          <FormItem label="客户类型">
            <RadioGroup v-model="investmentContractModel.type">
              <Radio label="10">企业</Radio>
              <Radio label="9">个人</Radio>
            </RadioGroup>
          </FormItem>
        </i-col>
      </Row>

      <Row :gutter="8" class="m-b-10">
        <i-col span="8">
          <FormItem prop="businessName" :label="investmentContractModel.type === '10' ? '客户名称(合同乙方)' : '承租人(合同乙方)'">
            <Input
              v-model="investmentContractModel.businessName"
              size="small"
              :placeholder="
                '请输入' +
                (investmentContractModel.type === '10'
                  ? '租户名称'
                  : '承租人')
              "
            />
          </FormItem>
        </i-col>

        <template v-if="investmentContractModel.type === '10'">
          <i-col span="8">
            <FormItem label="联系人姓名">
              <Input
                v-model="investmentContractModel.delegateName"
                size="small"
                placeholder="请输入公司联系人"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem  label="联系人电话">
              <Input
                v-model="investmentContractModel.delegatePhone"
                size="small"
                placeholder="请输入联系人电话号码"
              />
            </FormItem>
          </i-col>
        </template>
        <i-col v-else span="8">
          <FormItem  label="承租人电话">
            <Input
              v-model="investmentContractModel.tel"
              size="small"
              placeholder="请输入电话号码"
            />
          </FormItem>
        </i-col>
      </Row>

      <Row :gutter="8" class="m-b-10">
        <i-col span="24">
          <FormItem
            :label="
              investmentContractModel.type === '10'
                ? '统一社会信用代码'
                : '身份证号'
            "
          >
            <Input
              v-model="investmentContractModel.orgCode"
              size="small"
              :search="investmentContractModel.type === '10'"
              enter-button="自动录入"
              @on-search="writeOrgCode"
              :placeholder="
                '请输入' +
                (investmentContractModel.type === '10'
                  ? '统一社会信用代码'
                  : '身份证号')
              "
            />
          </FormItem>
        </i-col>
        <i-col span="24">
          <FormItem label="详细地址">
            <Row :gutter="8">
              <i-col span="4">
                <i-select
                  placeholder="省"
                  v-model="investmentContractModel.provinceCode"
                  clearable
                  size="small"
                  class="w-full"
                >
                  <Option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </Option>
                </i-select>
              </i-col>
              <i-col span="4">
                <i-select
                  placeholder="市"
                  v-model="investmentContractModel.cityCode"
                  clearable
                  size="small"
                  class="w-full"
                >
                  <Option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </Option>
                </i-select>
              </i-col>
              <i-col span="4">
                <i-select
                  placeholder="区"
                  v-model="investmentContractModel.areaCode"
                  clearable
                  size="small"
                  class="w-full"
                >
                  <Option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </Option>
                </i-select>
              </i-col>
              <i-col span="12">
                <Input
                  type="text"
                  size="small"
                  v-model="investmentContractModel.address"
                  placeholder="请输入详细地址"
                ></Input>
              </i-col>
            </Row>
          </FormItem>
        </i-col>

        <i-col span="24">
          <FormItem label="客户描述">
            <Input
              type="textarea"
              :rows="5"
              size="small"
              v-model="investmentContractModel.description"
              placeholder="请输入客户描述"
            ></Input>
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
    <Button type="text" class="m-r-5" @click="ContractCreateModal = false"
      >关闭</Button
    >
    <Button type="primary" :loading="btnLoading"  @click="handleSubmit">确定</Button>
  </div>
  </Modal>
</template>

<script>
// import { getPositions } from '@/api/product/resource'
// import { addDevice, updateDevice } from '@/api/product/deviceedit'

import { listDictLabel } from '@/api/contract/dict'
import {
  getProvinceList,
  getCityListByProvinceCode,
  getRegionListByCityCode
} from '@/api/sys/provincecityregion'
import { getCompanyList } from '@/api/os/company'
import { queryorgcodebycompanyfullname } from '@/api/scp/invoice'

/** new api */
import {
  listInvestmentProject,
  listSinInBusiness
} from '@/api/invest/invest'
import { createContract } from '@/api/invest/contract'

export default {
  components: {},
  props: {},
  data () {
    return {
      ContractCreateModal: false,
      PurposeTypeArray: [],
      provinceList: [],
      cityList: [],
      regionList: [],
      investmentArray: [],
      orderArray: [],

      rentStartDate: '',
      investmentContractModel: {
        companyId: null,
        businessName: '',
        code: '',
        contractName: '',
        purposeType: '2',
        type: '10',
        address: null,
        areaCode: '',
        cityCode: '',

        contractType: 1, // 1. 商业 2.通信

        delegateName: '', // 联系人姓名
        delegatePhone: '', // 联系人电话

        description: '',
        legalPerson: null,
        orgCode: null,
        provinceCode: '',
        tel: ''
      },
      ruleValidate: {
        businessName: [{ required: true, message: '客户名称/承租人不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '合同编号不能为空', trigger: 'blur' }],
        contractName: [{ required: true, message: '合同名称不能为空', trigger: 'blur' }]
      },
      btnLoading: false
    }
  },
  mounted () {
    this.initBaseData()
  },
  created () {},
  methods: {
    initBaseData () {
      this.getProvinceList()
      // this.initInvestment()
      listDictLabel({ dictType: 'purpose_type' }).then((res) => {
        this.PurposeTypeArray = res
      })
      // 获取合同甲方清单
      this.getCompanyData()
    },
    showModal () {
      this.ContractCreateModal = true
      this.investmentContractModel = {
        companyId: this.manageCompanyArray[0].id,
        businessName: '',
        code: '',
        contractName: '',
        purposeType: '2',
        type: '10',
        address: null,
        areaCode: '',
        cityCode: '',

        contractType: 1, // 1. 商业 2.通信

        delegateName: '', // 联系人姓名
        delegatePhone: '', // 联系人电话

        description: '',
        legalPerson: null,
        orgCode: null,
        provinceCode: '',
        tel: ''
      }
    },
    initInvestment () { // 获取招商内容， 目前已移至合同信息内部
      listInvestmentProject({ pageNumber: 1, pageSize: 66 }).then(
        (response) => {
          this.investmentArray = response.records
        }
      )
    },
    initOrderArray () {
      listSinInBusiness({
        investId: this.investmentContractModel.investId
      }).then((res) => {
        this.orderArray = res.filter((x) => x.orderStatus === 1)
      })
    },
    getCompanyData () {
      const params = { enabled: true, publisherId: this.$store.getters.token.userInfo.publisherId }
      getCompanyList(params).then(res => {
        if (res && !res.errcode) {
          this.manageCompanyArray = res
        } else {
          this.manageCompanyArray = []
        }
      })
    },
    getProvinceList () {
      getProvinceList().then((res) => {
        this.provinceList = res
      })
    },
    getCityList () {
      const data = {
        provinceCode: this.investmentContractModel.provinceCode
      }
      getCityListByProvinceCode(data).then((res) => {
        this.cityList = res
      })
    },
    getRegionList () {
      const data = {
        cityCode: this.investmentContractModel.cityCode
      }
      getRegionListByCityCode(data).then((res) => {
        this.regionList = res
      })
    },

    writeOrgCode () {
      if (this.investmentContractModel.businessName) {
        queryorgcodebycompanyfullname({
          companyName: this.investmentContractModel.businessName
        }).then((res) => {
          if (res) {
            this.investmentContractModel.orgCode = res.organizationCode
          } else {
            this.$Notice.error({
              desc: '未检索到社会统一信息代码，请确认租户名称是否正确或手动输入社会统一信息代码'
            })
          }
        })
      } else {
        this.$Notice.info({ desc: '您未输入公司名称！' })
      }
    },
    handleSubmit () {
      this.$refs.investmentContractModel.validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '操作提示',
            content: '请确认信息填写无误？',
            onOk: () => {
              // if (this.investmentId) {
              //   this.investmentContractModel.id = this.investmentId
              // }
              // this.$store.commit('set_investment_pageType', 'list')
              // this.investmentContractModel.rentStartDate = ParseDate(
              //   this.rentStartDate
              // )
              // this.deviceIds = this.choiceDeviceIdArray.toString()

              this.btnLoading = true
              createContract(this.investmentContractModel).then((res) => {
                if (res) {
                  this.ContractCreateModal = false
                  this.$Notice.success({ desc: '操作成功' })
                  this.$store.commit('set_contract_pageType', 'list')
                  this.$store.commit('set_contract_update', new Date())
                }
              }).finally(() => {
                this.btnLoading = false
              })
            }
          })
        }
      })
    },
    handleChoiceDevices () {
      this.$refs.deviceChoice.showModal()
    }
  },
  watch: {
    'investmentContractModel.provinceCode' (val) {
      if (val) {
        this.getCityList()
      } else {
        this.investmentContractModel.cityCode = ''
        this.investmentContractModel.areaCode = ''

        this.cityList = []
        this.regionList = []
      }
    },
    'investmentContractModel.cityCode' (val) {
      if (val) {
        this.getRegionList()
      } else {
        this.investmentContractModel.areaCode = ''
        this.regionList = []
      }
    },
    'investmentContractModel.investId' (val) {
      if (val) {
        this.initOrderArray()
      } else {
        this.investmentContractModel.orderNo = ''
        this.orderArray = []
      }
    }
  },
  computed: {}
}
</script>
